import { formatIndianPrice } from "../../../utils/formatIndianPrice"
import DashboardTable from "../utils/DashboardTable"


const DashTable = ({label,title,Count1,Count2,Count3,type = 1}) => {
  return (
    <div className="col-md-4">
         {console.log("check data is here",Count1,Count2,Count3)}
                   <div className="dashboard-card m-0" style={{ height: "100%" }}>
         {/* Table 1: GRN, Sales Order, Sales Invoice */}
         <DashboardTable
           title={label}
           type={type}
           rows={[
             {
               transaction: title[0],
               no: Count1?.option3,
               qty: Count1?.option1,
               value: type == 0 ? Count1?.option2 : `₹${formatIndianPrice(Count1?.option2 ? Count1?.option2 : 0)}`,
             },
             {
               transaction: title[1],
               no: Count2?.option3,
               qty: Count2?.option1,
               value: type == 0 ? Count2?.option2 : `₹${formatIndianPrice(Count2?.option2 ? Count2?.option2 : 0)}`,
             },
             {
               transaction: title[2],
               no: Count3?.option3,
               qty: Count3?.option1,
               value: type == 0 ? Count3?.option2 : `₹${formatIndianPrice(Count3?.option2 ? Count3?.option2 : 0)}`,
             },
           ]}
         />
         </div>
         </div>
  )
}

export default DashTable